export const GET_PROMO = "GET_PROMO";
export const GET_PROMO_SUCCESS = "GET_PROMO_SUCCESS";
export const GET_PROMO_FAILED = "GET_PROMO_FAILED";

export const SET_SELECTED_PROMO = "SET_SELECTED_PROMO";
export const RESET_SELECTED_PROMO = "RESET_SELECTED_PROMO";

export const SET_TEMP_PROMO_VALUE = "SET_TEMP_PROMO_VALUE";
